import React from "react";

export default function TabHeader({ tabs, active, onChange }) {
  return (
    <div className="tabs-row">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`tab-btn${tab === active ? " active" : ""}`}
          onClick={() => onChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
